import { render, staticRenderFns } from "./SelfAwareness.vue?vue&type=template&id=de4d8a06&scoped=true&"
import script from "./SelfAwareness.vue?vue&type=script&lang=js&"
export * from "./SelfAwareness.vue?vue&type=script&lang=js&"
import style0 from "./SelfAwareness.vue?vue&type=style&index=0&id=de4d8a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4d8a06",
  null
  
)

export default component.exports